// extracted by mini-css-extract-plugin
export default {"dragging":"SortableItem_dragging__0FrZQ"};